export class DealerFilter {
  names?: string[];
}
